import '@fontsource/atkinson-hyperlegible/400.css'
import '@fontsource/atkinson-hyperlegible/700.css'
import { createTheme } from '@mui/material/styles'
import alertTheme from './alert-theme'
import PaletteTheme from './palette-theme'

export const THEME_SPACING = 8

const theme = createTheme({
  spacing: THEME_SPACING,
  palette: PaletteTheme,
  typography: {
    h1: {
      fontSize: 64
    },
    h2: {
      fontSize: 48
    },
    h3: {
      fontSize: 40
    },
    h4: {
      fontSize: 32
    },
    fontFamily: ['Atkinson Hyperlegible', 'sans-serif'].join(',')
  },
  components: {
    MuiTablePagination: {
      defaultProps: {
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          display: 'none'
        }
      }
    },
    MuiSkeleton: {
      styleOverrides: {
        root: {
          backgroundColor: PaletteTheme.grey?.[50]
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: true
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
        size: 'small',
        InputLabelProps: { shrink: true }
      }
    },
    MuiSelect: {
      defaultProps: {
        variant: 'outlined',
        size: 'small'
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            backgroundColor: PaletteTheme.grey?.[25]
          }
        }
      }
    },
    MuiAlert: alertTheme(),
    MuiChip: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(!!ownerState.color &&
            ownerState.color != 'default' && {
              color: `var(--${ownerState.color}-700)`,
              backgroundColor: `var(--${ownerState.color}-50)`
            })
        }),
        deleteIcon: {
          color: 'var(--grey-300)',
          '&:hover': {
            color: 'var(--grey-200)'
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          textTransform: 'none',
          ...(ownerState.variant === 'text' && {
            color: ownerState.color ?? PaletteTheme.grey?.[500],
            fontSize: '14px',
            fontWeight: 700
          }),
          ...(['contained', 'outlined'].indexOf(ownerState.variant as string) > -1 && {
            fontSize: '15px',
            fontWeight: 700,
            borderRadius: '8px'
          })
        })
      },
      defaultProps: {
        disableElevation: true
      }
    },
    MuiMenu: {
      defaultProps: {
        PaperProps: { style: { borderRadius: (THEME_SPACING * 3) / 2 } }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '13px'
        }
      }
    },
    MuiSlider: {
      styleOverrides: {
        mark: {
          backgroundColor: 'var(--primary-500)',
          '&.MuiSlider-markActive': {
            backgroundColor: 'currentColor'
          },
          '&[style*="left:100%"], &[style*="left: 100%"]': {
            transform: 'translateX(-10px) translateY(-50%)'
          }
        },
        thumb: {
          '&[style*="left:0%"], &[style*="left: 0%"]': {
            transform: 'translateX(-5px) translateY(-50%)'
          },
          '&[style*="left:100%"], &[style*="left: 100%"]': {
            transform: 'translateX(-10px) translateY(-50%)'
          }
        }
      }
    }
  }
})

export default theme
